export default {
  idTitleLabel: 'Solicitud ',
  buttons: {
    exit: 'Regresar'
  },
  updatedDateLabel: 'Última actualización {0} hs',
  message: 'Aquí encontrará los archivos adjuntos a esta solicitud pendiente de revisión. Cuando se dictamine, cambiará su estado a Dictaminado y encontrará aquí el detalle.',
  tabs: {
    information: 'Información',
    observations: 'Observaciones'
  },
  information: {
    invoice: {
      label: 'Factura',
      authorizedAmount: 'Monto autorizado',
      productsTitle: 'Productos',
      productStatus: {
        rejected: 'Rechazado',
        approved: 'Aprobado'
      }
    }, 
    prescription: {
      label: 'Prescripción',
      diagnosesTitle: 'Diagnósticos',
      diagnosisStatus: {
        rejected: 'Rechazado',
        approved: 'Aprobado'
      }
    },
    otherFiles: {
      addFilesButton: 'Adjuntar',
      title: 'Archivos adicionales (opcional)',
      label: 'Documentos requeridos y relevantes para la autorización.'
    },
    settlementFiles: {
      title: 'Finiquito',
      addButtonLabel: 'Adjuntar finiquito',
      message: 'Es necesario adjuntar un archivo de finiquito para dar por finalizada esta solicitud'
    },
    resultFiles: {
      label: 'Resultados'
    },
    payment: {
      label: 'Información de Pago',
      documentLabel: 'Documento no.',
      accountLabel: 'Cuenta:',
      bankLabel: 'Banco:',
      paymentDate: 'Fecha de pago:'
    },
    preview: {
      title: 'Vista previa',
      label: 'Este archivo no tiene vista previa.',
      actions: {
        cancel: 'Cancelar',
        download: 'Descargar',
        delete: 'Eliminar'
      }
    },
    beneficiary: {
      name: 'Nombre completo',
      identification: 'Nº de Identificación',
      percentage: '% de beneficiario'
    }
  },
  observations: {
    addOtherFileComment: 'Se adjuntó el documento {name} a la solicitud.',
    addOtherFiles: {
      title: 'Archivos adicionales',
      addFilesTitle: 'Adjuntar archivos adicionales',
      uploadButton: 'Confirmar',
      cancelButton: 'Cancelar'
    },
    comments:{
      headerDatePrefix: 'Hoy {date}',      
      noComments: 'No hay observaciones',
      inputLabel: 'Escriba su comentario'
    } 
  }
}